// extracted by mini-css-extract-plugin
export default {"container":"FlightReportDetail_container__RjEuh"};